module.exports = __webpack_public_path__ + "assets/img/MoversBAPC.f4431f7a.png";